<p-fieldset legend="Designação da Comissão">
  <div class="row">
    <div class="col-12">
      <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="itemAtual">
        <i class="fa fa-plus"></i> Adicionar
      </button>
    </div>
  </div>
  <table class="table table-eddy table-sm">
    <thead>
      <tr>
        <th scope="col">Número</th>
        <th scope="col">Ano</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of comissao?.designacao">
        <td>
          <span *ngIf="!item.editavel">{{item.NumAtoDesignacao}}</span>
          <input *ngIf="item.editavel" type="text" class="form-control" [(ngModel)]="itemAtual.NumAtoDesignacao"
            [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
        </td>
        <td>
          <span *ngIf="!item.editavel">{{item.AnoAtoDesignacao}}</span>
          <input *ngIf="item.editavel" type="text" class="form-control" [(ngModel)]="itemAtual.AnoAtoDesignacao"
            [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
        </td>
        <td class="text-right">
          <button *ngIf="!item.editavel" (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
          </button>
          <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
          </button>
          <button *ngIf="item.editavel" (click)="salvar()" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
          </button>
          <button *ngIf="item.editavel" (click)="cancelar()" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</p-fieldset>